export default {
    VOTACAO: 1,
    PESQUISA: 2,
    PESQUISA_ASSISTIDA: 3,
  }
  


// WEBPACK FOOTER //
// ./src/config/TipoFormulario.js